// extracted by mini-css-extract-plugin
export default {"createRecipePage":"createrecipepage_createRecipePage__4Jly1","title":"createrecipepage_title__WExpi"};